import { useTranslation } from 'react-i18next'

import { statisticStatuses } from '@/common/components/Statistic/constants'
import Statistic from '@/common/components/Statistic/Statistic'
import StatisticGroup from '@/common/components/StatisticGroup/StatisticGroup'
import InfoTooltip from '@/metrics/components/InfoTooltip/InfoTooltip'
import {
  getAverageOrderValueKpi,
  getEarningsRetainedKpi,
  getOrderReturnRateKpi,
  getOrdersKpi,
} from '@/metrics/pages/PerformanceInsightsPage/GlobalTab/YourNumbersCard/helpers'

const PeriodKpis = ({ numbers }) => {
  const { t, i18n } = useTranslation()

  const orders = getOrdersKpi(numbers, t, i18n.language)
  const averageOrderValue = getAverageOrderValueKpi(numbers, t, i18n.language)
  const orderReturnRate = getOrderReturnRateKpi(numbers, t, i18n.language)
  const earningsRetained = getEarningsRetainedKpi(numbers, t, i18n.language)

  return (
    <StatisticGroup>
      <Statistic
        isOutlined={false}
        label={t('Pedidos')}
        labelAddon={<InfoTooltip text={t('Excluyendo pedidos borrador')} />}
        value={orders.value}
        caption={orders.caption}
      />
      <Statistic
        isOutlined={false}
        label={t('Valor medio de pedido')}
        labelAddon={<InfoTooltip text={t('Ventas netas ÷ número de pedidos.')} />}
        value={averageOrderValue.value}
        caption={averageOrderValue.caption}
      />
      <Statistic
        isOutlined={false}
        label={t('Tasa de devolución de pedidos')}
        labelAddon={
          <InfoTooltip
            text={t(
              'Pedidos con solicitud de devolución o cambio ÷ pedidos, contados desde la fecha de pedido original. Misma definición que la home.'
            )}
          />
        }
        value={orderReturnRate.value}
        caption={orderReturnRate.caption}
      />
      <Statistic
        isOutlined={false}
        label={t('Ventas retenidas')}
        labelAddon={
          <InfoTooltip
            text={t(
              'Ventas que conservas en vez de reembolsar, como saldo de tienda o cambios. Se cuentan por la fecha en que se resuelve cada devolución, así que pueden incluir devoluciones de pedidos anteriores.'
            )}
          />
        }
        value={earningsRetained.value}
        caption={earningsRetained.caption}
        status={statisticStatuses.success}
      />
    </StatisticGroup>
  )
}

export default PeriodKpis
